import { useState, useEffect, useRef, useMemo, memo } from 'react';
import { Accordion, ListGroup, Button, Col, Collapse, Nav, Row, Card } from 'react-bootstrap';
import { Link, useLocation, useNavigate,useNavigationType } from 'react-router-dom';
import useMessage from "../Hooks/useMessage";


export const Main = () => {
    const location = useLocation();
    const actionType = useNavigationType();
    const navigate = useNavigate();
    const [docUrl, setDocUrl] = useState('');
    const {Message, Error, Warning, cerrarAlertas} = useMessage();
    const [url, setUrl] = useState(
        location.search
            ? `${location.pathname}${location.search}&app=1`
            : `${location.pathname}?app=1`
    );
    function getURLParams(search) {
        let params = {};
        if (!search) return params;
        search = search.startsWith("?") ? search.slice(1) : search;
        search.split("&").forEach((pair) => {
            let [key, value] = pair.split("=");
            params[key] = decodeURIComponent(value || "");
        });
        return params;
    }

    useEffect(() => {
        let iframe = document.getElementById("CitrusFRM");
        if(iframe){
            try {
                if(actionType !== 'REPLACE' && actionType !== 'POP'){
                    // eslint-disable-next-line no-undef
                    Citrus.UI.loading(iframe,null,true);
                    const queryString = window.location.search;
                    const urlParams = getURLParams(queryString);
                    const tempUrl = new URL(
                        `${window.location.origin}${location.pathname}`
                    );
                    try {
                        if (Object.keys(urlParams).length > 0) {
                            for (let [key, value] of Object.entries(urlParams)) {
                                tempUrl.searchParams.append(key, value);
                            }
                        }
                        tempUrl.searchParams.append("app", "1");
                    }catch (e) {
                        tempUrl.searchParams.append("app", "1");
                    }
                    setUrl(tempUrl.toString());
                    const iframeWindow = iframe.contentDocument || iframe.contentWindow;
                    iframeWindow.location.href = tempUrl.toString();
                }
            } catch (error) {
                document.location.href = `${location.pathname}${location.search}`;
            }
        }
        else{
            document.location.href = `${location.pathname}${location.search}`;
        }
    }, [location]);
    const isValidUrl = (string) => {
        try {
            const newUrl = new URL(string);
            return newUrl.protocol === "http:" || newUrl.protocol === "https:";
        } catch (err) {
            return false;
        }
    };
    function onLoad() {
        let iframe = document.getElementById("CitrusFRM");
        try {
            if (iframe) {
                let docUrl = `${iframe.contentDocument.location.pathname}${iframe.contentDocument.location.search}`
                let tempUrl;
                if(isValidUrl(url)){
                    tempUrl = new URL(url);
                    tempUrl = `${tempUrl.pathname}${tempUrl.search}`
                }else{
                    tempUrl = url
                }
                if(docUrl !== tempUrl){
                    let docUrl = new URL(`${iframe.contentDocument.location.origin}${iframe.contentDocument.location.pathname}${iframe.contentDocument.location.search}`);
                    docUrl.searchParams.delete('app');
                    let tempDocUrl = `${docUrl.pathname}${docUrl.search}`
                    setDocUrl(tempDocUrl);
                    navigate(tempDocUrl, {replace: true})
                }
                resizeIFrame();
                let links = iframe.contentDocument.querySelectorAll("a");
                links.forEach(function (link) {
                    if (isValidUrl(link.href)) {
                        const url = new URL(link.href);
                        if (
                            !url.href.includes("#") &&
                            !(link.getAttribute("target") === "_blank")
                            && !url.href.includes("templates")
                        ) {
                            link.addEventListener("click", function (event) {
                                navigate(`${link.pathname}${link.search}`);
                            });
                        }
                    }
                });
                const handleOutsideClick = () => {
                    const customEvent = new Event("iframeOutsideClick", {
                        bubbles: true,
                        cancelable: true,
                    });
                    document.dispatchEvent(customEvent);
                };
                iframe.contentDocument.body.addEventListener(
                    "click",
                    handleOutsideClick
                );
                const iframeWindow = iframe.contentWindow || iframe.contentDocument;
                const body = iframeWindow.document.body;
                const element = body.querySelector("#main");
                addResizeObserver(iframe, element);
                addMutationObserver(iframe, body);
            }
        } catch (error) {
            // eslint-disable-next-line no-undef
            Citrus.UI.loading(iframe, null, false);
        }finally {
            // eslint-disable-next-line no-undef
            Citrus.UI.loading(iframe, null, false);
        }
    }
    function addResizeObserver(iframe, element) {
        const observer = new ResizeObserver((entries) => {
            const height = entries[0].contentRect.height;
            // eslint-disable-next-line no-restricted-globals
            const main = parent.document.querySelector(".main-panel");
            if (height !== element.scrollHeight) {
                requestAnimationFrame(() => {
                    main.style.height = `${height + 50}px`;
                    iframe.style.height = `${height + 25}px`;
                });
            }
        });
        observer.observe(element);
    }
    function addMutationObserver(iframe, element2) {
        const observer2 = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains("ui-dialog")) {
                        const rect = node.getBoundingClientRect();
                        const height = rect.height.toFixed(2);
                        // eslint-disable-next-line no-restricted-globals
                        const main = parent.document.querySelector(".main-panel");
                        if (height > parseInt(iframe.style.height)) {
                            requestAnimationFrame(() => {
                                main.style.height = `${height}px`;
                                iframe.style.height = `${height}px`;
                            });
                        }
                    }
                });
            });
        });
        observer2.observe(element2, { childList: true });
    }
    function resizeIFrame() {
        const iframe = document.getElementById("CitrusFRM");
        const iframeWindow = iframe.contentWindow || iframe.contentDocument;CitrusFRM
        const body = iframeWindow.document.body;
        const uiDialog = body.querySelector(".ui-dialog");

        if (uiDialog) {
            uiDialog.style.top = "200px";
        }

        const element = body.querySelector("#main");
        const height = element.scrollHeight;
        // eslint-disable-next-line no-restricted-globals
        const main = parent.document.getElementById("MainRoot");

        requestAnimationFrame(() => {
            main.style.height = `${height + 50}px`;
            iframe.style.height = `${height + 25}px`;
        });
    }
    
    const [errorMessages, setErrorMessages] = useState(window.ErrorMessages);
    const [warningMessages, setWarningMessages] = useState(window.WarningMessages);
    const [messages, setMessages] = useState(window.NormalMessages);

    useEffect(() => {
        const handleWarningMessagesChange = (event) => {
            setWarningMessages(event.detail);
        };
        const handleErrorMessagesChange = (event) => {
            setErrorMessages(event.detail);
        };
        const handleNormalMessagesChange = (event) => {
            setMessages(event.detail);
        };
        const handleClearMessages = (event) => {
            cerrarAlertas();
        };
        window.addEventListener('warningMessages', handleWarningMessagesChange);
        window.addEventListener('errorMessages', handleErrorMessagesChange);
        window.addEventListener('normalMessages', handleNormalMessagesChange);
        window.addEventListener("clearMessages", handleClearMessages);
        return () => {
            window.removeEventListener('warningMessages', handleWarningMessagesChange);
            window.removeEventListener('errorMessages', handleErrorMessagesChange);
            window.removeEventListener('normalMessages', handleNormalMessagesChange);
            window.removeEventListener("clearMessages", handleClearMessages);
        };
    }, []);
    
    useEffect(() => {
        if(warningMessages?.length > 0){
            Warning({messages: warningMessages})
            setWarningMessages([]);
            window.WarningMessages = null;
        }
        if(errorMessages?.length > 0){
            Error({messages: errorMessages})
            setErrorMessages([]);
            window.ErrorMessages = null;
        }
        if(messages){
            let newMsg = messages.filter(m => m !== 'Sólo se exportarán los primeros 10,000 resultados de su búsqueda.');
            if(newMsg?.length > 0){
                Message({messages: newMsg})
                setMessages([]);
                window.NormalMessages = null;
            }
        }
    },[warningMessages, messages, errorMessages])
    
    return (
        <>
            <iframe
                src={url}
                id="CitrusFRM"
                scrolling="no"
                style={{
                    border: "none",
                    width: "100%",
                    height: "1080px",
                    minHeight: "100vh",
                }}
                onLoad={onLoad}
            ></iframe>
        </>
    );
};